import * as Yup from "yup";

export const eventoFiscalValidator = Yup.object().shape({
  descricaoEvento: Yup.string().required("Descrição do evento"),
  codigoEvento: Yup.string().required("Código do evento"),
  dataPrevistaEntrega: Yup.date().nullable(),
  fatNfSaidaId: Yup.number().nullable(),
  chaveAcesso: Yup.string().required("Chave de acesso"),
  estNfEntradaId: Yup.number().nullable(),
  aceiteCreditoDebitoNota: Yup.string().nullable(),
});
